import{useState as t}from"react";const a=()=>{const[e,o]=t(!1),[s,r]=t(!0);return{drawerOpen:e,drawerShow:s,toggleDrawerOpen:()=>{r(!1),setTimeout(()=>{o(!e),r(!0)},100)}}};export{a as useDrawer};
